import { type CSSProperties } from 'react';
import { Outlet } from 'react-router-dom';
import { useBrandTokens, TopBar } from './shared';

export function HomeShellLayout() {
  const brandTokens = useBrandTokens();

  return (
    <div
      className="pc-desk"
      style={
        {
          ...brandTokens,
          display: 'grid',
          gridTemplateColumns: '1fr',
          gridTemplateRows: 'var(--topbar-height) 1fr',
          height: '100vh',

          fontFamily: 'var(--font-family)',
        } as CSSProperties
      }
    >
      <TopBar />

      {/* Full-width content area */}
      <div
        style={{
          padding: 'var(--content-inset)',
          overflow: 'auto',
        }}
      >
        <div
          style={{
            background: 'var(--bg-surface)',
            borderRadius: 'var(--main-card-radius)',
            boxShadow: 'var(--shadow-paper)',
            height: '100%',
            overflow: 'auto',
            padding: 'var(--sp-6)',
          }}
        >
          <Outlet />
        </div>
      </div>
    </div>
  );
}
